import React from "react";
import { useParams, Redirect } from "react-router-dom";
import { ServiceProviderR } from "../../../pages/service-provider/routes";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { FeatureStatus, useFeatureAvailability } from "../hooks";

export const FeatureEnabledOrgOnly: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const { orgId } = useParams<{ orgId: string }>();
  const { status } = useFeatureAvailability(orgId);

  const breadcrumbs = [
    { to: ServiceProviderR.Home.link({}), title: "テナント一覧" },
    {
      to: ServiceProviderR.ProcManagement.link({ orgId }),
      title: "手続きマスタ",
    },
  ];

  const statusComponentMap = {
    [FeatureStatus.Available]: <>{children}</>,
    [FeatureStatus.Unavailable]: (
      <Redirect to={ServiceProviderR.ProcManagement.link({ orgId })} />
    ),
    [FeatureStatus.Loading]: (
      <ServiceProviderTemplate breadcrumbs={breadcrumbs} />
    ),
  };
  return statusComponentMap[status];
};

export default FeatureEnabledOrgOnly;
